/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { Amount } from "../../types/amount";
import { FlexContainer } from "../../containers/FlexContainer";
import { DetailsRightColumnText } from "./elements/DetailsRightColumnText";
import styled from "@emotion/styled";
import { Hash } from "viem";
import { getTokenTicker } from "../../utils/tokenUtils";
import { useTokenListByChain } from "../../hooks/useTokenListByChain";

/**
 *
 * We can probably have something smarter which checks number of decimals of the USD price,
 * this is specifically for values where only 1 token doesn't yield a great exchange and
 * so if we truncate the exchange rate to 5dp then you get 0.0000.
 */
export const ExchangeRate: React.FC<{
  tokenAddress: Hash;
  oppositeSymbolAddress: Hash;
  price: Amount;
  flippedPrice: Amount;
}> = ({ tokenAddress, oppositeSymbolAddress, price, flippedPrice }) => {
  const [switchRate, setSwitchRate] = useState(false);
  const tokenList = useTokenListByChain();
  return (
    <FlexContainer>
      <Row onClick={() => setSwitchRate(!switchRate)}>
        {switchRate ? (
          <DetailsRightColumnText>
            1 {getTokenTicker(tokenAddress, tokenList)} = {flippedPrice.format(5)}{" "}
            {getTokenTicker(oppositeSymbolAddress, tokenList)}
          </DetailsRightColumnText>
        ) : (
          <DetailsRightColumnText>
            1 {getTokenTicker(oppositeSymbolAddress, tokenList)} = {price.format(5)}{" "}
            {getTokenTicker(tokenAddress, tokenList)}
          </DetailsRightColumnText>
        )}
      </Row>
    </FlexContainer>
  );
};

// Sub-components

const Row = styled.button``;
